import type { IconProps } from "@/types/IconProps";

export function Facebook(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m1.666 5.038a3.49 3.49 0 0 0-3.49 3.49V9.93H8.782l-.276 2.776h1.672v5.589h2.79v-5.589h2.515l.277-2.776h-2.791V8.527a.7.7 0 0 1 .698-.698h2.093V5.04z"></path>
    </svg>
  );
}
